/** Status summary chips for Monthly / Probationary appraisal lists. */

export const STATUS_SUMMARY_CHIPS = [
  {
    key: "delayed",
    label: "Delayed",
    statuses: ["delayed", "delay"],
  },
  {
    key: "completed",
    label: "Completed",
    statuses: [
      "completed",
      "auto_approved",
      "signed_off",
      "approved",
      "level_one_approved",
      // Fallback when API has not yet stamped status on aggregate rows
      "active",
    ],
  },
  {
    key: "pending",
    label: "Pending",
    statuses: [
      "pending",
      "draft",
      "sent_to_rtm",
      "sent_rtm",
      "returned_to_supervisor",
      "rejected",
      "level_one_rejected",
      "auto_rejected",
    ],
  },
];

export const STATUS_SUMMARY_KEYS = new Set(
  STATUS_SUMMARY_CHIPS.map((chip) => chip.key)
);

const STATUS_TO_SUMMARY_KEY = STATUS_SUMMARY_CHIPS.reduce((acc, chip) => {
  chip.statuses.forEach((status) => {
    acc[status] = chip.key;
  });
  return acc;
}, {});

export function normalizeStatusKey(value) {
  let key = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  if (key === "sent_rtm") key = "sent_to_rtm";
  if (key === "delay") key = "delayed";
  return key;
}

export function isStatusSummaryKey(value) {
  return STATUS_SUMMARY_KEYS.has(normalizeStatusKey(value));
}

export function getStatusSummaryKey(statusValue) {
  const key = normalizeStatusKey(statusValue);
  return STATUS_TO_SUMMARY_KEY[key] || null;
}

export function getRowStatusKey(row) {
  const raw =
    row?.status ??
    row?.appraisal_status ??
    row?.workflow_status ??
    row?.paf_status ??
    "";

  if (raw == null || raw === "") return "pending";

  if (typeof raw === "string" || typeof raw === "number") {
    return normalizeStatusKey(raw);
  }
  if (raw?.name) return normalizeStatusKey(raw.name);
  if (Array.isArray(raw) && raw.length > 0) {
    return normalizeStatusKey(raw[0]?.name ?? raw[0] ?? "pending");
  }
  return "pending";
}

export function countStatusSummary(rows) {
  const counts = STATUS_SUMMARY_CHIPS.reduce((acc, chip) => {
    acc[chip.key] = 0;
    return acc;
  }, {});

  (rows || []).forEach((row) => {
    const summaryKey = getStatusSummaryKey(getRowStatusKey(row));
    if (summaryKey && counts[summaryKey] != null) {
      counts[summaryKey] += 1;
    }
  });

  return counts;
}

export function rowMatchesStatusSummary(row, summaryKey) {
  const key = normalizeStatusKey(summaryKey);
  if (!STATUS_SUMMARY_KEYS.has(key)) return false;
  return getStatusSummaryKey(getRowStatusKey(row)) === key;
}
